export class UsersFiltersRequest {
  id?: number;
  nickname?: string;
  email?: string;
  facebook_id?: string;
  bought_credits_min?: number;
  page?: string;
}
